import { render, staticRenderFns } from "./TeachResList.vue?vue&type=template&id=7ec0c68f&"
import script from "./TeachResList.vue?vue&type=script&lang=js&"
export * from "./TeachResList.vue?vue&type=script&lang=js&"
import style0 from "./TeachResList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports